import React, { useState } from "react";
import styles from "./pivot-dropdown.scss";
import { useEffect } from "react";
import { useRef } from "react";
import NestedDropdown from "../../../../../components/nested-dropdown/nested-dropdown";
import {
  DIMENSIONS,
  PIVOT_DROPDOWN_ORDER,
  PIVOT_NAMES,
} from "../../../constants";

const PivotDropdown = ({
  selected,
  attributes,
  onSelect,
  filterDefinitions,
  partialData,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef();

  const onAnyClick = (e) => {
    if (!containerRef.current.contains(e.target)) setIsOpen(false);
  };

  const handleSelect = (toSelect) => {
    const dIndex = parseInt(
      Object.keys(PIVOT_NAMES).find((key) => PIVOT_NAMES[key] === toSelect.main)
    );
    if (toSelect.sub) onSelect(dIndex, toSelect.sub);
    else onSelect(dIndex);
    setIsOpen(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", onAnyClick);

    return () => {
      document.removeEventListener("mousedown", onAnyClick);
    };
  }, []);

  const DIMENSIONS_TO_FILTER_DISPLAY_NAME = {
    [DIMENSIONS.manufacturer]: "Manufacturer",
    [DIMENSIONS.sellers]: "Seller",
    [DIMENSIONS.subCategory]: "Sub-category",
  };

  const hasAnyValues = (values) => {
    if (!values) return false;
    if (Array.isArray(values)) return values.length > 0;
    return Object.values(values).some((v) => hasAnyValues(v));
  };

  const dropdownOptions = PIVOT_DROPDOWN_ORDER
    .map((p) => {
      if (p !== DIMENSIONS.attribute &&
          p !== DIMENSIONS.manufacturer &&
          p !== DIMENSIONS.sellers &&
          p !== DIMENSIONS.subCategory) {
        return { key: PIVOT_NAMES[p] };
      }
      
      if (p === DIMENSIONS.manufacturer || p === DIMENSIONS.sellers || p === DIMENSIONS.subCategory) {
        const filterDef = filterDefinitions?.find(
          (x) => x.displayName === DIMENSIONS_TO_FILTER_DISPLAY_NAME[p]
        );
        const noData = filterDef ? !hasAnyValues(filterDef.values) : false;
        
        // Disable Sellers if partial data OR no data available
        const shouldDisable = (p === DIMENSIONS.sellers && partialData) || noData;
        
        return {
          key: PIVOT_NAMES[p],
          disabled: shouldDisable,
        };
      }
      
      return {
        key: PIVOT_NAMES[p],
        options: attributes.map((x) => ({ key: x })),
        disabled: attributes.length === 0,
      };
    });
  return (
    <div className={styles.dropDownWrapper}>
      <div className={styles.dropDownTitlesWrapper}>
        <div className={styles.dropDownPreTitle}>Analyze by</div>
        <div
          className={styles.dropDownToggle}
          onClick={() => setIsOpen(true)}
          ref={containerRef}
        >
          <div className={styles.dropDownTitle}>
            {PIVOT_NAMES[selected.main]}
            {selected.sub && `: ${selected.sub}`}
            <span className={styles.arrowDown}></span>
          </div>
          {isOpen && (
            <NestedDropdown
              options={dropdownOptions}
              onSelect={handleSelect}
              selected={{
                main: PIVOT_NAMES[selected.main],
                sub: selected.sub,
              }}
              allowSubDropdown={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PivotDropdown;
